<template>
  <div class="container">
    <BaseLoader
      v-if="cargando"
    />
    <div class="contenedor_tabla_mentoria" v-else>
      <div class="contenedor_socios_lista contenedor_tabla_mentores">
        <table id="tabla-socio-lista">
          <thead>
            <th>Nombre</th>
            <th>Apellido</th>
          </thead>
          <tbody>
            <MentoresListaItem
              v-for="mentor in mentores"
              :mentor="mentor"
              :key="mentor.mentor_id"
            ></MentoresListaItem>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import MentoresListaItem from '../components/MentoresListaItem.vue'
import mentorService from '../services/mentor'
import BaseLoader from '../components/BaseLoader.vue'
export default {
  name: 'MentoriasLista',
  components: {
    MentoresListaItem,
    BaseLoader
  },
  data: function () {
    return {
      cargando: false,
      mentores: []
    }
  },
  methods: {
  },
  mounted: function () {
    this.cargando = true
    mentorService
      .traerMentoresTodos()
      .then(respuesta => {
        this.cargando = false
        this.mentores = respuesta
        console.log('Todos los Mentores', respuesta)
      })
  }
}
</script>
